import Flickity from "flickity";

const carouselGeneric = () => {
  const elements = document.querySelectorAll(".js-carousel");

  if (!elements) return;
    elements.forEach((element) => {
      const flkty = new Flickity(element, {
        imagesLoaded: true,
        wrapAround:   true,
        cellAlign:    'center',
        contain:      true,
        prevNextButtons: true,
        pageDots:     false,
        autoPlay:     2500,
        pauseAutoPlayOnHover: false,
    });

    return flkty;
  })
}

export default carouselGeneric;